<template>
  <div class="system-wrap">
    <Tabs type="card">
      <TabPane label="策划支持">
        <scheme-config></scheme-config>
      </TabPane>
      <TabPane label="技术支持">
        <footConfig></footConfig>
      </TabPane>
      <TabPane label="公众号配置">
        <wxConfig></wxConfig>
      </TabPane>
      <TabPane label="前端链接">
        <frontLink></frontLink>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import wxConfig from "./component/wx-config";
import footConfig from "./component/footer-config";
import SchemeConfig from "./component/scheme-config";
import frontLink from "./component/front-link.vue";

export default {
  name: "system",
  components: {
    wxConfig,
    footConfig,
    SchemeConfig,
    frontLink,
  },
  data() {
    return {
      // query参数
      query: {},
      // 搜索
      search: {},
      // DOM操作
      diyDom: {},
      // 自定义数据
      diyData: {},
      // 接口数据
      apiData: {},
    };
  },
  methods: {},
  created() {},
};
</script>

<style scoped lang="less"></style>
